import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Link } from '@mui/material';
import DropdownButton from '../DropdownButton';
import { useStyles } from './styles';

const Props = {
  folder: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  onEnter: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onOptionClick: PropTypes.func.isRequired,
};

export default function FolderCard({ folder, onEnter, options, onOptionClick }) {
  const classes = useStyles();

  return (
    <div className={classes.card}>
      <Link onClick={onEnter} underline="hover">
        <div className={classes.cardMedia}>
          <img src="/images/folder-icon.svg" alt="Folder icon" />
        </div>
      </Link>

      <div>
        <Typography className={classes.cardText} variant="body2" color="textSecondary">
          <Link onClick={onEnter} underline="hover">
            {folder.name}
          </Link>
        </Typography>

        <DropdownButton options={options} onOptionClick={onOptionClick} />
      </div>
    </div>
  );
}

FolderCard.propTypes = Props;
